import { createAction } from '@reduxjs/toolkit'

export const removeDeviceFromAllStores = /*@__PURE__*/ createAction<string>('[Device] remove')
